import { computed } from 'vue';
import debounce from '@/utils/Debounce';
import store from '@/store';
import TabsKind from '@/enums/tabs.enum';
import globals from '@/utils/global';

export default class App {
	TabsKind = TabsKind;

	text = computed((): string => store.getters.getText());

	onTextChange = debounce((text: string) => {
		void store.actions.updateSuggestions(text);
	}, 250);

	tabs = computed(() => store.getters.getTabs());
	selectedTab = computed(() => store.getters.getSelectedTab());
	dependencyReady = computed(() => store.getters.areDependenciesReady());
	hasNoResults = computed(() => store.getters.getResults(TabsKind.PROGRAMMES).length === 0);
	showResultsTab = computed(() => this.text.value.length >= globals.MIN_SEARCH_LENGTH);

	constructor() {
		void store.actions.loadDisciplineFacets();
	}
}